<script>
import apiServices from "@/services/yungol-services";
const XLSX = require("xlsx");

export default {
  template: `<div id='actions-frsm'>
    <p class='buttons'>
      <a class="button is-success is-small" style='padding: 15px !important;' v-on:click="editProcess()">
        <span class="icon is-small">
          <i class="material-icons">edit</i>
        </span>
      </a>
      <a class="button is-danger is-small" style='padding: 15px !important;' v-on:click="deleteR()">
        <span class="icon is-small">
          <i class="material-icons">delete_forever</i>
        </span>
      </a>
      <a class="button is-link is-small" :class='status.down ? "is-loading" : ""' style='padding: 15px !important;' v-on:click="download()">
        <span class="icon is-small">
          <i class="material-icons">cloud_download</i>
        </span>
      </a>
    </p>
  </div>`,
  data() {
    return {
      value: "",
      params: this.$parent.params,
      status: {
        down: false,
      },
    };
  },
  beforeMount() {
    this.value = this.params.value;
  },
  methods: {
    editProcess() {
      this.$emit("editProcess", this.params.data);
    },
    deleteR() {
      const config = {
        title: "¿Estás seguro?",
        text: "Al eliminar no se podrá recuperar el informe después",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };

      this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          const deleteAttached = this.$fire.deleteFolderAttached(
            this.params.data.id
          );
          if (!deleteAttached) {
            await this.$store.dispatch("notify", {
              message: "Error al eliminar los anexos.",
              type: "is-danger",
              duration: 4000,
              position: "top-center",
            });
          } else {
            // Eliminar el proceso completamente
            await apiServices.delete(`/informefrs/${this.params.data.id}`);
            this.params.api.applyTransaction({
              remove: [this.params.node.data],
            });
            await this.$swal({
              text: "Informe eliminado correctamente.",
              icon: "success",
              showConfirmButton: false,
              timer: 1700,
            });
          }
        }
      });
    },
    // Download Data
    widthCols(data) {
      let values = [];
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = { width: String(data[i][d]).length + 2 };
            values.push(w);
          }
          //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = String(data[i][d]).length + 2;
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = String(key).length + 2;
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
    download() {
      const params = this.params;
      const d = [
        params.data.responses,
        params.data.nombre,
        params.data.dataAdmin,
      ];
      if (d[0] || d[2]) {
        let dataFrs = [];

        if (this.params.tokenUser["admin"]) {
          for (let i = 0; i < d[2]["grupos"].length; i++) {
            let nameG = d[2]["grupos"][i];
            let subsG = d[2][nameG];

            for (let j = 0; j < subsG.length; j++) {
              let subgrupo = {
                Grupo: subsG[j]["Grupo"],
                SubGrupo: subsG[j]["SubGrupo"],
                Check1: subsG[j]["check"] ? "Verdadero" : "Falso",
                Check2: subsG[j]["check2"] ? "Verdadero" : "Falso",
                CountData: subsG[j]["countData"]["sum"],
              };
              dataFrs.push(subgrupo);
            }
          }
        } else {
          for (let i = 0; i < d[0]["original"].length; i++) {
            let nameO = d[0]["original"][i];
            let subsG = d[0][nameO]["SubGrupo"];
            for (let j = 0; j < subsG.length; j++) {
              let subgrupo = {
                Grupo: nameO,
                SubGrupo: subsG[j],
              };
              dataFrs.push(subgrupo);
            }
          }
        }

        //  Asignamos la informacion necesaria a nuevas variables
        let name = "Datos Frs " + d[1];
        //  Se agrega la data al libro de excel
        const ws = XLSX.utils.json_to_sheet(dataFrs);

        //  Se configura el tamaño de cada columna
        ws["!cols"] = this.widthCols(dataFrs);

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos Frs");
        const nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);
      } else {
        this.$store.dispatch("notify", {
          message: `Error no hay datos para descargar`,
          type: "is-danger",
        });
      }
    },
  },
};
</script>
<style lang="scss">
#actions-frsm {
  width: 100% !important;
  height: 100% !important;
  margin-top: 7px;
}

.buttons {
  flex-wrap: nowrap !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/buttons-action.vue